import React, { useEffect, useRef, useState } from 'react';

export const STATUS_OPTIONS = [
    { key: 'Not Saved', label: 'Not Saved', dot: 'status-dot-unsaved' },
    { key: 'Prospect', label: 'Prospect', dot: 'status-dot-prospect' },
    { key: 'Client', label: 'Client', dot: 'status-dot-client' },
    { key: 'Lapsed Client', label: 'Lapsed Client', dot: 'status-dot-lapsed' },
    { key: 'Rejected', label: 'Rejected', dot: 'status-dot-rejected' },
];

export const dotFor = (status) =>
    STATUS_OPTIONS.find((s) => s.key === status)?.dot || 'status-dot-unsaved';

/* Colour class for anything showing a status: prospect orange, client green,
 * lapsed brown, rejected red (status-tint-* in freightsource.css). */
export const tintFor = (status) => dotFor(status).replace('status-dot-', 'status-tint-');

const StatusSelect = ({ traderId, value, onChange, placement = 'right' }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return;
        const onDoc = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', onDoc);
        return () => document.removeEventListener('mousedown', onDoc);
    }, [open]);

    const pick = (key, e) => {
        e.stopPropagation();
        setOpen(false);
        onChange(traderId, key);
    };

    return (
        <span
            className="status-select"
            ref={ref}
            onClick={(e) => e.stopPropagation()}
        >
            <button
                type="button"
                className={`status-trigger ${tintFor(value)}`}
                onClick={() => setOpen((v) => !v)}
            >
                <span className={`dot ${dotFor(value)}`} />
                <span>{value}</span>
                <span className="caret">▾</span>
            </button>
            {open && (
                <div
                    className="status-menu"
                    style={placement === 'left' ? { right: 'auto', left: 0 } : undefined}
                >
                    {STATUS_OPTIONS.map((opt, i) => (
                        <React.Fragment key={opt.key}>
                            <button
                                type="button"
                                className={opt.key === value ? 'on' : ''}
                                onClick={(e) => pick(opt.key, e)}
                            >
                                <span className={`dot ${opt.dot}`} />
                                {opt.label}
                            </button>
                            {i === 0 && <hr />}
                        </React.Fragment>
                    ))}
                </div>
            )}
        </span>
    );
};

export default StatusSelect;
